import api from 'tim-api';
import { duplicateActivation as duplicateActivationEndPoint } from 'endPoints';

export const state = {
  duplicateActivation: [],
  filter: {},
  pagination: {}
};

export const getters = {
  duplicateActivationList: (state: Object) => state.duplicateActivation,
  pagination: (state: Object) => state.pagination,
  filter: (state: Object) => state.filter,
};

export const mutations = {
  SET_DUPLICATEACTIVATIONLIST(state: Object, duplicateActivation: Array<Object>) {
    state.duplicateActivation = duplicateActivation;
  },
  SET_PAGINATION(state: Object, pagination: Object) {
    state.pagination = pagination;
  },
  SET_FILTER(state: Object, filter: Object) {
    state.filter = filter;
  }
};

export const actions = {
  fetchduplicateActivationList({ commit }: Action, filter: Object) {
    commit('SET_DUPLICATEACTIVATIONLIST', []);
    commit('SET_PAGINATION', {});
    commit('SET_FILTER', []);
    return api.post(`${duplicateActivationEndPoint}`, filter).then(({ data }) => {
      commit('SET_DUPLICATEACTIVATIONLIST', data.data);
      commit('SET_PAGINATION', {
        current_page: data.data.current_page,
        first_page_url: data.data.first_page_url,
        from: data.data.from,
        last_page: data.data.last_page,
        last_page_url: data.data.last_page_url,
        next_page_url: data.data.next_page_url,
        path: data.data.path,
        per_page: data.data.per_page,
        prev_page_url: data.data.prev_page_url,
        total: data.data.total
      });
      commit('SET_FILTER', filter);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
